import * as XLSX from "xlsx";
import io from "socket.io-client";
import { PORT } from "./constant";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export const downloadExcel = (data, name) => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
  //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
  XLSX.writeFile(workbook, `${name}.xlsx`);
};

export const generateExcel = async () => {
  // Create a new workbook
  const workbook = new ExcelJS.Workbook();

  // Define your worksheets and data
  const sheetsData = [
    {
      name: "Sheet1",
      headers: ["Header1", "Header2", "Header3"],
      rows: [
        ["Data1", "Data2", "Data3"],
        ["Data4", "Data5", "Data6"],
      ],
    },
    {
      name: "Sheet2",
      headers: ["Column1", "Column2", "Column3"],
      rows: [
        ["Value1", "Value2", "Value3"],
        ["Value4", "Value5", "Value6"],
      ],
    },
  ];

  // Add worksheets and data
  sheetsData.forEach((sheetData, index) => {
    const sheet = workbook.addWorksheet(sheetData.name);

    // Add headers
    const headerRow = sheet.addRow(sheetData.headers);

    // Set header styles (background color)
    headerRow.eachCell((cell, colNumber) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: index % 2 === 0 ? "FFFF0000" : getRandomColor() }, // Red or Random color
      };
      cell.font = { bold: true };
    });

    // Add data rows
    sheetData.rows.forEach((row) => {
      sheet.addRow(row);
    });
  });

  // Generate Excel and download
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, "MultiSheetExcel.xlsx");
};

// Helper function to generate random colors
const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return `FF${color}`; // ExcelJS expects ARGB format
};

// export const downloadExcel1 = (dataArray, namesArray, headingsArray) => {
//     const workbook = XLSX.utils.book_new();

//     dataArray.forEach((data, index) => {
//         // Add an empty row before each table
//         data.unshift({});
//         data.unshift({});

//         // Add table name as the first row
//         data.unshift({ [namesArray[index]]: "" });

//         // Calculate the start row of the table
//         const startRow = index === 0 ? 3 : dataArray[index - 1].length + 6;

//         const worksheet = XLSX.utils.json_to_sheet(data, { header: headingsArray[index] });

//         // Add the worksheet with appropriate start row
//         XLSX.utils.book_append_sheet(workbook, worksheet, namesArray[index], { origin: `A${startRow}` });
//     });

//     XLSX.writeFile(workbook, "MultiTableReport.xlsx");
// };

export const downloadExcel1 = (dataArray, namesArray, headingsArray) => {
  const workbook = XLSX.utils.book_new();

  dataArray.forEach((data, index) => {
    // Calculate the start row of the table
    const startRow = index === 0 ? 0 : dataArray[index - 1].length + 2;

    const worksheet = XLSX.utils.json_to_sheet(data, {
      header: headingsArray[index],
    });

    // Add the worksheet with appropriate start row
    XLSX.utils.book_append_sheet(workbook, worksheet, namesArray[index], {
      origin: `A${startRow}`,
    });
  });

  XLSX.writeFile(workbook, "MultiTableReport.xlsx");
};

export const downloadExcel11 = async (dataArray, namesArray) => {
  const workbook = new ExcelJS.Workbook();

  dataArray.forEach((data, index) => {
    const worksheet = workbook.addWorksheet(namesArray[index]);

    // Check if data is available and has at least one row
    if (data && data.length > 0) {
      const headers = Object.keys(data[0]);

      // Add header row
      const headerRow = worksheet.addRow(headers);

      // Apply red background color to the headers
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFF0000" }, // Red background
        };
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } }; // White text
      });

      // Add data rows
      data.forEach((rowData) => {
        worksheet.addRow(Object.values(rowData));
      });

      // Optionally, you can auto-fit columns
      worksheet.columns.forEach((column) => {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const columnLength = cell.value ? cell.value.toString().length : 10;
          if (columnLength > maxLength) {
            maxLength = columnLength;
          }
        });
        column.width = maxLength < 10 ? 10 : maxLength;
      });
    }
  });

  // Generate Excel and download
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, "MultiTableReport.xlsx");
};

export const downloadAllData = (
  footFallData,
  revenueReport,
  perPersonRevenueReport,
  businessForcastReport,
  timeTrendLunch,
  timeTrendDinner
) => {
  const workbook = new ExcelJS.Workbook();

  const addWorksheetWithData = (workbook, data, sheetName) => {
    const worksheet = workbook.addWorksheet(sheetName);
    data.forEach((row) => {
      worksheet.addRow(row);
    });
  };

  addWorksheetWithData(workbook, footFallData, "footFallData");
  addWorksheetWithData(workbook, revenueReport, "revenueReport");
  addWorksheetWithData(
    workbook,
    perPersonRevenueReport,
    "perPersonRevenueReport"
  );
  addWorksheetWithData(
    workbook,
    businessForcastReport,
    "businessForcastReport"
  );
  addWorksheetWithData(workbook, timeTrendLunch, "timeTrendLunch");
  addWorksheetWithData(workbook, timeTrendDinner, "timeTrendDinner");

  workbook.xlsx.writeBuffer().then((buffer) => {
    saveAs(new Blob([buffer]), "all_data.xlsx");
  });
};

export const getNewOrderFromSocket = (outletId) => {
  const socket = io.connect(PORT, {
    reconnect: true,
    query: `outletId=${outletId}`,
  });
  return socket;
};
